/**
 * Footer Component.
 */
export class Footer {
  /**
   * Css class that displays footer below <main>.
   *
   * @type {string}
   */
  static cssClassFluid = 'footer-fluid';

  /**
   * Css class that displays footer at the bottom of the window.
   *
   * @type {string}
   */
  static cssClassFixed = 'footer-fixed';

  /**
   * Inits the footer listener and update position on comon elements callback.
   */
  static initListener() {
    if (window.o_confCommon !== undefined) {
      window.o_confCommon.callbackFooter = Footer.updatePosition;
      window.onresize = () => {
        Footer.updatePosition();
      };
    }
  }

  /**
   * Updates footer position depending on available height.
   */
  static updatePosition() {
    const headerDOM = document.querySelector('header');
    const headerHeight = headerDOM ? headerDOM.offsetHeight : 0;
    const mainDOM = document.querySelector('main');
    const mainHeight = mainDOM ? mainDOM.offsetHeight : 0;
    const footerDOM = document.querySelector('footer');
    const footerHeight = footerDOM ? footerDOM.offsetHeight : 0;
    const combinedContainersHeight = headerHeight + mainHeight + footerHeight;
    const windowHeight = window.innerHeight;

    Footer.updateClass(footerDOM, windowHeight, combinedContainersHeight);
  }

  /**
   * Update Footer class.
   *
   * @param   {obj}  footerDOM - The footer DOM object.
   * @param   {int}  windowHeight - The window height (in px).
   * @param   {int}  combinedContainersHeight - The combined height of the 3 main containers (in px).
   */
  static updateClass(footerDOM, windowHeight, combinedContainersHeight) {
    if (footerDOM) {
      if (windowHeight > combinedContainersHeight) {
        if (footerDOM.className.indexOf(Footer.cssClassFluid) !== -1) {
          const fluidRegex = new RegExp(`(\\s|^)${Footer.cssClassFluid}(\\s|$)`);

          footerDOM.className = footerDOM.className.replace(fluidRegex, 'footer-fixed');
        }
      } else if (footerDOM.className.indexOf(Footer.cssClassFixed) !== -1) {
        const fixedRegex = new RegExp(`(\\s|^)${Footer.cssClassFixed}(\\s|$)`);

        footerDOM.className = footerDOM.className.replace(fixedRegex, 'footer-fluid');
      }
    }
  }
}
